import { Dropdown } from "./Dropdown";
import classNames from "classnames";
import styles from "./Dropdown.module.scss";
import { ReactNode, useState } from "react";
import cn from "classnames";
import IconAngleDown from "@/public/img/icons/svg/angle-down.svg";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import Link from "next/link";

const ButtonComponent = ({ onClick, buttonProps }: any) => {
  const { placeholder, value, items } = buttonProps;

  const selectedItem = items.find((item: any) => item.id === value);

  return (
    <button
      className={cn(styles.dropdownLinksSelectBtn, {
        [styles.dropdownLinksSelectBtnPlaceholder]: !selectedItem,
      })}
      onClick={onClick}
    >
      {selectedItem?.name || placeholder}

      <SpriteIcon icon={IconAngleDown} className={styles.dropdownLinksSelectBtnIcon} />
    </button>
  );
};

const ItemComponent = ({ item, onClick, itemProps }: any) => {
  const { setValue } = itemProps;
  return (
    <Link
      href={item.url}
      onClick={() => {
        onClick();
        setValue(item.id);
      }}
    >
      {item.name}
    </Link>
  );
};

export type DropdownLinksProps = {
  className?: string;
  placeholder?: string;
  items: {
    id: number | string;
    url: string;
    name: string | number | ReactNode;
  }[];
};
export const DropdownLinksSelect = ({ placeholder, className, items }: DropdownLinksProps) => {
  const [value, setValue] = useState(null);
  return (
    <Dropdown
      className={classNames(styles.dropdownLinksSelect, className)}
      items={items}
      ButtonComponent={ButtonComponent}
      ItemComponent={ItemComponent}
      buttonProps={{ placeholder, value }}
      itemProps={{ value, setValue }}
    />
  );
};
